import { useQuery } from '@tanstack/react-query';
import { supplyChainService } from '../services/apiClient';

// Re-export shared types if needed, or define them here if not available globally
// Ideally these should be in a types file, but for now we'll match the existing pattern
// We are expecting the consumer to handle specific types, but we'll return the raw data

export const useForecastQuery = (warehouse: string = 'all', enabled: boolean = true) => {
    return useQuery({
        queryKey: ['forecast', warehouse],
        queryFn: async () => {
            console.log(`Fetching forecast for warehouse: ${warehouse}`);
            const response = await supplyChainService.getForecast(warehouse);
            return response;
        },
        enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000,   // 10 minutes
        refetchOnWindowFocus: false,
    });
};
